import { render, staticRenderFns } from "./data-management-other.vue?vue&type=template&id=663107cc&"
import script from "./data-management-other.vue?vue&type=script&lang=js&"
export * from "./data-management-other.vue?vue&type=script&lang=js&"
import style0 from "./data-management-other.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports